import { render, staticRenderFns } from "./FiltersTransactions.vue?vue&type=template&id=3073ba08&"
import script from "./FiltersTransactions.vue?vue&type=script&lang=js&"
export * from "./FiltersTransactions.vue?vue&type=script&lang=js&"
import style0 from "./FiltersTransactions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports